module.exports = __webpack_public_path__ + "images/common/store_noimage_comingsoon_d0da17c96428a54efe1d4eadeb0dc26c.png";